var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("iframe", {
    attrs: {
      src: _vm.pdfUrl,
      width: "100%",
      height: "600px",
      frameborder: "0",
      scrolling: "no",
      title: _vm.$translate(
        "ETCeresCoconut::Template.etcAllgemeinArtikelProduktdatenblatt"
      )
    },
    on: { load: _vm.onLoad }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }